import {
  ProjectSection,
  ProjectSectionContent,
} from 'layouts/Project';
import { motion } from 'framer-motion';
import { quotes } from '../data';
import styles from '../Stack.module.css';

// Quote card component
const QuoteCard = ({ quote, index }) => {
  return (
    <motion.article
      className={styles.quoteCard}
      data-favorite={quote.favorite}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
    >
      <span className={styles.quoteIcon}>&ldquo;</span>
      <blockquote className={styles.quoteText}>
        {quote.text}
      </blockquote>
      <footer className={styles.quoteAttribution}>
        <cite className={styles.quoteAuthor}>— {quote.author}</cite>
        {quote.source && (
          <span className={styles.quoteSource}>{quote.source}</span>
        )}
      </footer>
    </motion.article>
  );
};

export function QuotesContent() {
  return (
    <ProjectSection padding="none" className={styles.section}>
      <ProjectSectionContent className={styles.quotesContent}>
        <div className={styles.quotesGrid}>
          {quotes.map((quote, index) => (
            <QuoteCard key={quote.id} quote={quote} index={index} />
          ))}
        </div>
      </ProjectSectionContent>
    </ProjectSection>
  );
}
